<template>
  <div class="content">
    <div class="wallet-history">
      <accountDetail tab-name="deposit-record" />
      <p class="title">
        {{ $t("Bao.deposit_detail") }}
      </p>
      <div class="history-list">
        <div class="history-date-frame">
          <div class="history-date">
            <p>{{ $t("Bao.date") }}: <datePicker v-model="dateRange" @query="oneQuery" /></p>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <scroll-loader :loader-method="query" :loader-disable="!enableAutoLoad" />
        </div>
        <div class="table-frame">
          <div v-if="record.length === 0" class="history-data-none">
            <div class="data-none-img">
              <img :src="$getThemeImagePath('no-data.png')" alt="">
            </div>
            <div class="data-none-title">
              {{ $t('Bao.no_relevant_data_records') }}
            </div>
            <div class="data-none-description">
              {{ $t('Bao.search_results_are_empty') }}
            </div>
          </div>
          <table v-else class="history-date-table">
            <thead>
              <tr>
                <th>{{ $t("Bao.time") }}</th>
                <th>{{ $t("Bao.ref_id") }}</th>
                <th>{{ $t("Bao.wallet_action") }}</th>
                <th>{{ $t("Bao.deposit_for_record") }}</th>
                <th>{{ $t("Bao.receive") }}</th>
                <th>{{ $t("Bao.change") }}</th>
                <th>{{ $t("Bao.status") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, key) in record" :key="key">
                <td :data-title="$t('Bao.time')">
                  {{ processedAndSplitDate(item.create_at)[0] }}
                  <br>
                  {{ processedAndSplitDate(item.create_at)[1] }}
                </td>
                <td :data-title="$t('Bao.wallet_action')">
                  {{ item.ref_id }}
                </td>
                <td :data-title="$t('Bao.wallet_action')">
                  {{ item.method }} {{ item.channel ? ' - ' + item.channel : '' }}
                </td>
                <td :data-title="$t('Bao.deposit_for_record')">
                  {{ item.request_amount | numberFormat }}
                </td>
                <td :data-title="$t('Bao.receive')">
                  {{ item.amount | numberFormat }}
                </td>
                <td :data-title="$t('Bao.change')">
                  {{ item.exchange_rate | numberFormat }}
                </td>
                <td :data-title="$t('Bao.status')">
                  {{ item.status_label }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="history-list-m">
        <div class="history-date">
          <span>{{ $t("Bao.deposit_detail") }}</span>
          <p>{{ $t("Bao.date") }}: <datePicker v-model="dateRange" @query="oneQuery" /></p>
        </div>
        <div class="history-card-list">
          <div v-if="record.length === 0" class="history-card">
            <div class="history-data-none">
              <div class="data-none-img">
                <img :src="$getThemeImagePath('no-data.png')" alt="">
              </div>
              <div class="data-none-title">
                {{ $t('Bao.no_relevant_data_records') }}
              </div>
              <div class="data-none-description">
                {{ $t('Bao.search_results_are_empty') }}
              </div>
            </div>
          </div>
          <div v-for="(item, key) in record" v-else :key="key" class="history-card">
            <table class="history-date-table-m">
              <tbody>
                <tr>
                  <td class="history-title-m">
                    {{ $t("Bao.time") }}
                  </td>
                  <td :data-title="$t('Bao.time')" class="history-data-m">
                    {{ item.create_at | fullDateTimeFormat }}
                  </td>
                </tr>
                <tr>
                  <td class="history-title-m">
                    {{ $t("Bao.ref_id") }}
                  </td>
                  <td :data-title="$t('Bao.ref_id')" class="history-data-m">
                    {{ item.ref_id }}
                  </td>
                </tr>
                <tr>
                  <td class="history-title-m">
                    {{ $t("Bao.wallet_action") }}
                  </td>
                  <td :data-title="$t('Bao.wallet_action')" class="history-data-m">
                    {{ item.method }} {{ item.channel ? ' - ' + item.channel : '' }}
                  </td>
                </tr>
                <tr>
                  <td class="history-title-m">
                    {{ $t("Bao.deposit_for_record") }}
                  </td>
                  <td :data-title="$t('Bao.deposit_for_record')" class="history-data-m">
                    {{ item.request_amount | numberFormat }}
                  </td>
                </tr>
                <tr>
                  <td class="history-title-m">
                    {{ $t("Bao.receive") }}
                  </td>
                  <td :data-title="$t('Bao.receive')" class="history-data-m">
                    {{ item.amount | numberFormat }}
                  </td>
                </tr>
                <tr>
                  <td class="history-title-m">
                    {{ $t("Bao.change") }}
                  </td>
                  <td :data-title="$t('Bao.change')" class="history-data-m">
                    {{ item.exchange_rate | numberFormat }}
                  </td>
                </tr>
                <tr>
                  <td class="history-title-m">
                    {{ $t("Bao.status") }}
                  </td>
                  <td :data-title="$t('Bao.status')" class="history-data-m">
                    {{ item.status_label }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import accountDetail from '@/components/accountDetail'
import datePicker from '@/components/datePicker'
import { depositRecord } from '@/api/payment'
import moment from 'moment'
import ScrollLoader from 'vue-scroll-loader/src/components/Scroll-Loader'

export default {
  components: {
    accountDetail,
    datePicker,
    ScrollLoader
  },
  data() {
    return {
      dateRange: {
        startDate: moment().subtract(7, 'd').toDate(),
        endDate: new Date()
      },
      status: 'all',
      record: [],
      page: 1,
      pageSize: 50,
      enableAutoLoad: true,
      loading: false,
      firstLoad: true
    }
  },
  async created() {
    this.query()
  },
  methods: {
    async query() {
      if (this.loading) return
      this.loading = true
      this.firstLoad = false
      const queryObj = {
        'startDate': moment(this.dateRange.startDate).format('YYYY/MM/DD'),
        'endDate': moment(this.dateRange.endDate).format('YYYY/MM/DD'),
        'page': this.page,
        'page_size': this.pageSize
      }
      if (this.status !== 'all') {
        queryObj.status = this.status
      }
      const res = await depositRecord(queryObj)
      this.record = [...this.record, ...res.data.data.list]
      if (res.data.data.list.length < this.pageSize) {
        this.enableAutoLoad = false
      } else {
        this.enableAutoLoad = true
        this.page += 1
      }
      this.loading = false
      this.firstLoad = false
    },
    oneQuery() {
      this.enableAutoLoad = true
      this.page = 1
      this.record = []
      this.query()
    },
    processedAndSplitDate(formattedTime) {
      const formattedValue = this.$options.filters.fullDateTimeFormat(formattedTime)
      const dataParts = formattedValue.split(' ')
      return dataParts
    }
  }
}
</script>
